import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { DEFAULT_LOCALE, getPreferredLocale, isLocale, localePath } from './publicPaths';

/** Redirige vers un chemin public dans la locale de l’URL courante. */
export const LocaleRedirect = ({ to }) => {
  const { locale } = useParams();
  return <Navigate to={localePath(to, isLocale(locale) ? locale : DEFAULT_LOCALE)} replace />;
};

/** Redirige une ancienne URL sans préfixe vers /ar ou /fr selon la langue mémorisée. */
export const PreferredLocaleRedirect = ({ path = '/' }) => {
  return <Navigate to={localePath(path, getPreferredLocale())} replace />;
};

export default LocaleRedirect;
